import { ReactComponent as TitleProFirst } from "assets/svg/header-pro-title-first.svg";
import { ReactComponent as TitleProSecond } from "assets/svg/header-pro-title-second.svg";
import { TextSection } from "components/TextSection";
import { useRef, useEffect, useState } from "react";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";

import { ReactComponent as BodySVG } from "assets/content/results/body.svg";
import { ReactComponent as ChatSVG } from "assets/content/results/chat.svg";
import { ReactComponent as PostureSVG } from "assets/content/results/posture.svg";
import { ReactComponent as ForkAndSpoonSVG } from "assets/content/results/fork_spoon.svg";
import { ReactComponent as StandSVG } from "assets/content/results/stand.svg";
import { ReactComponent as FlashSVG } from "assets/content/results/flash.svg";
import { ReactComponent as BackSideSVG } from "assets/content/results/back_side.svg";
import { ReactComponent as EdemaSVG } from "assets/content/results/edema.svg";
import { ReactComponent as YogaSVG } from "assets/content/results/yoga.svg";
import { ReactComponent as ImmuneSVG } from "assets/content/results/immune.svg";

import { HeroImageContainer } from "components/HeroImageContainer";
import { Footer } from "components/Footer";
import { Products } from "components/Products";
import { HeaderPro } from "components/HeaderPro";
import { Contraindications } from "components/Contraindications";

const HeroSection = ({ scrollTo }: { scrollTo: (name: string) => void }) => {
  return (
    <>
      <div className="relative bg-red-100 lg:hidden">
        <div className="clip-hero-bg-white relative h-screen bg-white sm:flex">
          <div className="clip-hero-bg-mobile absolute flex h-full w-full bg-heroBgMobile bg-cover bg-center bg-no-repeat"></div>
        </div>
        <div className="absolute bottom-6 flex h-1/2 w-full flex-col content-center items-center justify-end font-ristretto">
          <div className="text-8xl font-semibold leading-none text-red-500">
            ШпакМетод
          </div>
          <div className="text-8xl font-semibold leading-none text-cyan-600">
            &nbsp;MIX
          </div>
          <div className="text-4xl font-bold text-gray-800 mt-4">
            🔥 Сжигает жир в 9 раз быстрее! 🔥
          </div>
          <div
            onClick={() => scrollTo("buy")}
            className="text-xl mt-4 w-52 cursor-pointer rounded-md bg-red-500 p-3 text-center uppercase text-white"
          >
            Купить
          </div>
        </div>
      </div>
      <div className="hidden h-screen w-auto bg-rose-200 md:hidden lg:visible lg:flex">
        <div className="clip-header-white relative flex w-2/5 bg-white bg-cover bg-center bg-no-repeat">
          <div className="clip-header z-10 flex w-full bg-red-100 bg-alinaLay bg-cover bg-center bg-no-repeat"></div>
        </div>
        <div className="mx-auto flex	w-1/2 flex-wrap content-center items-center justify-center gap-8">
          <div className="mr-4 mt-8 flex flex-grow-0 gap-2 font-ristretto">
            <div className="text-8xl font-semibold leading-none text-red-500">
              ШпакМетод
            </div>
            <div className="text-8xl font-semibold leading-none text-cyan-600">
              _MIX
            </div>
          </div>
          <div className="text-4xl font-bold text-gray-800">
            🔥 Сжигает жир в 9 раз быстрее! 🔥
          </div>
          <div
            onClick={() => scrollTo("buy")}
            className="text-xl w-52 cursor-pointer rounded-md bg-red-500 p-3 text-center uppercase text-white"
          >
            Купить
          </div>
        </div>
      </div>
    </>
  );
};

const liAgreeStyle =
  "before:content-['✅'] before:-left-6 before:text-xl before:absolute relative";

const liArrowStyle =
  "before:content-['➡️'] before:-left-6 before:text-xl before:absolute relative";

const liFireWorkStyle =
  "before:content-['💥'] before:-left-6 before:text-xl before:absolute relative";

const liExclamationStyle =
  "before:content-['ℹ️'] before:-left-6 before:text-xl before:absolute relative";

const liRestrictedStyle =
  "before:content-['❌'] before:-left-6 before:text-xl before:absolute relative";

const liConsultationStyle =
  "before:content-['⚠️'] before:-left-6 before:text-xl before:absolute relative";

const ContraindicationsPro = () => {
  const contraindication = (
    <div>
      <h2>Противопоказания</h2>
      
      <h3 className="text-red-600 font-bold">Абсолютные:</h3>
      <ul className="list-none mb-6">
        <li className={liRestrictedStyle}>Беременность</li>
        <li className={liRestrictedStyle}>Язва желудка (в период обострения)</li>
        <li className={liRestrictedStyle}>
          Любые заболевания сердца: сердечная недостаточность, аритмия, тахикардия, перенесённый инфаркт, ишемическая болезнь сердца и т. п.
        </li>
        <li className={liRestrictedStyle}>Эпилепсия</li>
        <li className={liRestrictedStyle}>Диафрагмальная грыжа</li>
        <li className={liRestrictedStyle}>Травмы и грыжи позвоночника</li>
      </ul>
      
      <h3 className="text-yellow-600 font-bold">Только по согласованию с врачом:</h3>
      <ul className="list-none">
        <li className={liConsultationStyle}>Гипертония 2 и 3 степени</li>
        <li className={liConsultationStyle}>Удалённая почка (нефрэктомия)</li>
        <li className={liConsultationStyle}>
          Серьёзные проблемы со зрением (высокая степень близорукости, глаукома и т. п.)
        </li>
        <li className={liConsultationStyle}>
          Любые заболевания сосудов, в том числе слабость сосудов
          (о ней могут свидетельствовать частые синяки, гематомы, «лопающиеся» сосуды, носовые кровотечения и пр.)
        </li>
        <li className={liConsultationStyle}>Киста яичника</li>
        <li className={liConsultationStyle}>Мочекаменная и желчекаменная болезнь (в период обострения)</li>
      </ul>
    </div>
  );
  return (
    <TextSection
      className="bg-gray-100 pt-4"
      margin="mt-0"
      content={contraindication}
    />
  );
};

const AboutSection = () => {
  const content = (
    <div>
      <h1>
        Шпак Метод Mix
      </h1>
      <p>
        <strong>
          В 9 раз быстрее сжигает жир, очищает организм, снижает аппетит, ускоряет обменные процессы, улучшает эмоциональное состояние.
        </strong>
      </p>

      <p>
        Шпак Метод Mix — это самая комплексная и продвинутая тренировка в системе. Здесь соединяются разные техники дыхания, активные упражнения и темы личной трансформации.
      </p>

      <p>
        Эта тренировка не только про тело, но и про то, как мы дышим, думаем, чувствуем и живём. <strong>Она снижает тревожность, улучшает качество сна, поддерживает обмен веществ даже ночью, замедляет старение и помогает сохранить молодость.</strong>
      </p>

      <p>
        Это тренировка, где мы работаем на нескольких уровнях одновременно:
      </p>

      <ul className="list">
        <li className={liAgreeStyle}>
          <strong>Диафрагмальное дыхание двух типов:</strong>
          <ul className="ml-6 mt-2">
            <li>с задержкой дыхания — для запуска активного жиросжигания и очистки</li>
            <li>без задержки — для насыщения тканей кислородом и стабилизации энергии</li>
          </ul>
        </li>
        <li className={liAgreeStyle}>
          <strong>Динамичные и статичные упражнения</strong>, направленные на проработку всех зон: живот, бёдра, талия, руки, ягодицы
        </li>
        <li className={liAgreeStyle}>
          <strong>Темы осознанности и эмоциональной зрелости</strong> — для внутренней опоры и устойчивости
        </li>
      </ul>
      <p>
        Такой подход запускает <strong>биохимические процессы</strong>, которые помогают телу использовать жир в качестве топлива, восстанавливают гормональный фон и <strong>реально повышают уровень энергии, нормализует работу нервной системы.</strong>
      </p>

      <h2>Метод MIX подойдёт вам, если вы:</h2>
      <ul className="list">
        <li className={liAgreeStyle}>
          Мечтаете уменьшить объёмы в проблемных зонах — особенно в области живота, боков, талии и бёдер.
        </li>
        <li className={liAgreeStyle}>
          Хотите женственную, подтянутую фигуру — без перекачанных мышц и без изнурительных тренировок, не отказываясь от жизни в удовольствии.
        </li>
        <li className={liAgreeStyle}>
          <strong>Хотите простой и понятный формат</strong> — основная тренировка занимает всего до 15 минут в день, выполняется натощак и не требует оборудования.
        </li>
        <li className={liAgreeStyle}>
          Ищете лёгкий способ запустить жиросжигание — без беговых дорожек, спортзала и силовых тренировок.
        </li>
        <li className={liAgreeStyle}>
          Открыты к новому: возможно, вы даже не знали, что дыхание — это мощный инструмент для похудения, тонуса и энергии.
        </li>
        <li className={liAgreeStyle}>
          Готовы не просто худеть, а работать над собой глубже — на уровне тела, эмоций и внутренней энергии. Чувствуете, что тело — это только часть вас, и готовы к более целостному подходу.
        </li>
      </ul>
      
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-6">
        <p className="text-sm text-yellow-800">
          ⚠️ Имеются противопоказания. Перед началом занятий рекомендуется консультация специалиста.
        </p>
      </div>

      <h2>Бонус: Мандалы — для гармонии и баланса</h2>
      <p>
        В развлекательной части курса вы создадите мандалы — это творческая практика, которая:
      </p>
      <ul className="list">
        <li className={liAgreeStyle}>
          гармонизирует мужскую и женскую энергии внутри вас и в пространстве вокруг;
        </li>
        <li className={liAgreeStyle}>
          балансирует правое и левое полушария мозга (логика и интуиция, порядок и вдохновение);
        </li>
        <li className={liAgreeStyle}>
          очищает от накопленного негатива и восстанавливает душевное равновесие;
        </li>
        <li className={liAgreeStyle}>
          помогает настроиться на внутреннюю целостность, уверенность и спокойствие.
        </li>
      </ul>
      <p>
        Эта часть курса — как отдых для ума и души, пока тело работает через дыхание.
      </p>

      <h2>Почему важно участвовать регулярно</h2>
      <p>
        Каждая тренировка в Шпак Методе уникальна. Мы используем разные упражнения в сочетании с дыхательными техниками, и каждый раз — это <strong>новая точка входа в тело</strong>.
      </p>
      <p>
        Метод строится как <strong>система</strong>, а не как разрозненные упражнения. Поэтому важно быть в потоке — тело быстро откликается, когда получает <strong>последовательную и разнообразную нагрузку</strong>.
      </p>

      <div className="bg-gradient-to-r from-rose-100 to-pink-100 p-6 rounded-lg border-l-4 border-rose-500 my-8">
        <p className="text-lg font-medium text-gray-800">
          📌 Шпак Метод MIX — это дыхательная тренировка, которая сжигает жир, возвращает силу и делает тело подтянутым. Это не фитнес. Это активация жизни через дыхание.
        </p>
      </div>

    </div>
  );
  return (
    <>
      <TextSection content={content} />
    </>
  );
};

const Results = () => {
  const resultIconStyle =
    "text-white text-sm flex flex-col items-center gap-4 h-52 w-52 mb-10";
  const textSpanStyle = "flex text-center text-xs p-2";

  return (
    <div className="prose mx-auto min-w-full gap-x-4 bg-rose-500 p-4 text-center">
      <h1 className="mt-20 font-serif text-white">
        Результаты от техники ШпакМетод MIX:
      </h1>
      <div className="flex w-full flex-col flex-wrap content-center items-center justify-between md:flex-row">
        <div className={resultIconStyle}>
          <div className="flex h-28 w-28  content-center items-center justify-center">
            <BodySVG />
          </div>
          <div>
            <span className={textSpanStyle}>
              Уменьшится объём тела (размеры одежды)
            </span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <BackSideSVG />
          </div>
          <div>
            <span className={textSpanStyle}>Укрепление мышцы тазового дна</span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <ForkAndSpoonSVG />
          </div>
          <div>
            <span className={textSpanStyle}>
              Сократится объём желудка, cнизится аппетит
            </span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <EdemaSVG />
          </div>
          <div>
            <span className={textSpanStyle}>Уйдут отеки и лишняя вода</span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <PostureSVG />
          </div>
          <div>
            <span className={textSpanStyle}>Выравнивание осанки</span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <ImmuneSVG height="100%" />
          </div>
          <div>
            <span className={textSpanStyle}>Нормализуется нервная система</span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <FlashSVG height="100%" />
          </div>
          <div>
            <span className={textSpanStyle}>Повысится уровень энергии</span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <ChatSVG height="100%" />
          </div>
          <div>
            <span className={textSpanStyle}>
              Научитесь любить себя и других людей
            </span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28  w-28 items-center justify-center">
            <YogaSVG height="100%" />
          </div>
          <div>
            <span className={textSpanStyle}>
              Повысится уровень концентрации и дисциплины
            </span>
          </div>
        </div>
        <div className={resultIconStyle}>
          <div className="flex h-28 w-28 items-center justify-center md:h-28 md:w-28">
            <StandSVG height="100%" />
          </div>
          <div>
            <span className={textSpanStyle}>
              Появится уверенность в себе и вкус жизни
            </span>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

const HowItGoes = () => {
  const howPass = (
    <div>
      <h2>Структура тренировочной недели</h2>
      <p>
        В течение 7 дней, каждое утро в 08:00 по московскому времени, участницы получают новый видеоурок в закрытом Telegram-канале. Он включает:
      </p>
      <ol>
        <li className={liAgreeStyle}>Детальный разбор новых упражнений</li>
        <li className={liAgreeStyle}>Тренировку, актуальную на день занятия</li>
        <li className={liAgreeStyle}>Теоретический-развлекательный блок</li>
      </ol>
      <p>
        В первый день подробно разбирается необходимая техника дыхания.
      </p>
      <p>
        Также в программе — лекции приглашённых специалистов по теме тренировок: гинекологов, косметологов, нейропсихолога и других экспертов, делящихся практическими советами.
      </p>
      
      <div className="bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-lg border-l-4 border-cyan-500 my-6">
        <h3 className="text-lg font-bold text-cyan-800 mb-4">🎁 Приглашенный спикер косметолог-дерматовенеролог</h3>
        <p className="text-cyan-900 mb-4">Бонусом вы получите:</p>
        <ul className="list">
          <li className={liAgreeStyle}>Лекцию по Домашней безопасной чистке лица</li>
          <li className={liAgreeStyle}>Лекцию по ежедневному домашнему уходу за лицом</li>
          <li className={liAgreeStyle}>Лекцию по избавлению от отека лица с помощью массажа гуаша</li>
        </ul>
      </div>
      <p>
        В итоге вы получаете отработанный комплекс упражнений на каждый день, рассчитанный на месяц.
      </p>
      <p>
        Уроки доступны в записи — вы проходите их в удобное для себя время. Доступ ко всей неделе тренировок и сопутствующим материалам сохраняется на 14 дней с момента старта.
      </p>
      <p>
        При выборе тарифа с обратной связью проверка домашних заданий проводится только в течение первых 7 дней с момента начала курса — в закрытой группе WhatsApp.
      </p>

      <h3>Что нужно для занятий</h3>
      <ul>
        <li className={liAgreeStyle}>
          Коврик или большое полотенце
        </li>
        <li className={liAgreeStyle}>По желанию: антицеллюлитный крем, крем для груди, маски, патчи — как часть ухода за собой</li>
        <li className={liAgreeStyle}>
          Пространство дома или на улице, где вам комфортно
        </li>
        <li className={liAgreeStyle}>
          Зеркало или фронтальная камера — для самостоятельного контроля выполнения упражнения
        </li>
        <li className={liAgreeStyle}>
          Одежда — любая, в которой вы чувствуете себя комфортно, можно заниматься в нижнем белье или голышом.
        </li>
        <li className={liAgreeStyle}>
          Установленное приложение Telegram и стабильный интернет
        </li>
      </ul>
    </div>
  );
  return <TextSection content={howPass} />;
};

const liExlamationStyle =
  "before:content-['❗'] before:-left-6 before:text-xl before:absolute relative";

const Rules = () => {
  const rulesContent = (
    <div>
      <h2>Условия участия</h2>
      <h3><strong>Шаг 1. Оплата</strong></h3>
      <p>
        Оформляется на сайте <a href="https://ilovebodyflex.online" className="text-rose-600">ilovebodyflex.online</a> через систему Robokassa. Пожалуйста, внимательно указывайте личные данные. С ошибками невозможно предоставить доступ и поддержку.
      </p>

      <h3><strong>Шаг 2. Подключение к тренировке</strong></h3>
      <p>
        После оплаты вам необходимо отправить запрос в <strong>закрытый Telegram-канал</strong>, где будут проходить все занятия. Добавление в канал занимает до 2-х дней.
      </p>
      <p>
        Вот ссылка на канал: <a href="https://t.me/+LZlmsjuKTT42YjQy" className="text-rose-600 underline">перейти в канал.</a>
      </p>
      <p>
        Если возникли вопросы или сложности — пишите в техподдержку <a href="https://t.me/shpakmetod" className="text-rose-600">@shpakmetod</a> в Telegram (ежедневно с 9:00 до 22:00 по московскому времени).
      </p>

      <h2 className="block text-rose-500">Обратите внимание</h2>
      <p>— После начала курса оплата не возвращается и не переносится ни по каким причинам</p>
      <p>— Копирование и распространение материалов запрещено и защищено законом</p>
      <p>— Контент и стиль подачи определяются автором метода. Комментарии и предложения не рассматриваются</p>
      <p>— Перед участием убедитесь в отсутствии противопоказаний, при необходимости проконсультируйтесь с врачом</p>
      <p>— Придерживаемся принципа персональной ответственности за свое здоровье.</p>
    </div>
  );
  return <TextSection content={rulesContent} />;
};


const BeforeAfter = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  
  const img1 = require("assets/content/before-after/IMG_6223.JPG");
  const img2 = require("assets/content/before-after/IMG_6224.JPG");
  const img3 = require("assets/content/before-after/IMG_6225.JPG");
  const img4 = require("assets/content/before-after/IMG_6226.JPG");
  const img5 = require("assets/content/before-after/IMG_6227.JPG");
  const img6 = require("assets/content/before-after/IMG_6228.JPG");
  const img7 = require("assets/content/before-after/IMG_6229.JPG");
  const img8 = require("assets/content/before-after/IMG_6264.JPG");
  const img9 = require("assets/content/before-after/IMG_6231.JPG");
  
  const images = [
    { src: img1, alt: "Результат участницы тренировки" },
    { src: img2, alt: "Результат участницы тренировки" },
    { src: img3, alt: "Результат участницы тренировки" },
    { src: img4, alt: "Результат участницы тренировки" },
    { src: img5, alt: "Результат участницы тренировки" },
    { src: img6, alt: "Результат участницы тренировки" },
    { src: img7, alt: "Результат участницы тренировки" },
    { src: img8, alt: "Результат участницы тренировки" },
    { src: img9, alt: "Результат участницы тренировки" },
  ];

  const handleLeftClick = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleRightClick = () => {
    if (images.length > currentSlide + 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    const touch = e.changedTouches[0];
    const deltaX = touch.clientX - touchStartX;
    if (deltaX === 0) return;
    if (deltaX > 0) {
      if (currentSlide === 0) return;
      setCurrentSlide(currentSlide - 1);
    } else {
      if (currentSlide >= images.length - 1) return;
      setCurrentSlide(currentSlide + 1);
    }
  };

  const carouselButtonClass =
    "absolute flex top-1/2 -translate-y-1/2 items-center justify-center p-2 rounded-full border-2 z-10 border-transparent w-14 h-14 focus:outline-none focus:shadow-outline";
  const carouselButtonLeftClass =
    carouselButtonClass +
    " left-6 md:left-[18%] lg:left-[23%]" +
    (currentSlide === 0 ? " opacity-10" : "");
  const carouselButtonRightClass =
    carouselButtonClass +
    " right-6 md:right-[18%] lg:right-[23%]" +
    (currentSlide === images.length - 1 ? " opacity-10" : "");

  return (
    <div className="prose mx-auto py-8 max-w-full">
      <h2 className="text-center mb-8">До и после Шпак Метода</h2>
      <div 
        className="relative overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <button className={carouselButtonLeftClass} onClick={handleLeftClick}>
          <AiOutlineLeftCircle className="w-14 h-14 text-rose-500 hover:text-rose-600 transition-colors" />
        </button>
        <button className={carouselButtonRightClass} onClick={handleRightClick}>
          <AiOutlineRightCircle className="w-14 h-14 text-rose-500 hover:text-rose-600 transition-colors" />
        </button>
        
        <div
          className="flex transition duration-500"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {images.map((image, index) => (
            <div key={index} className="w-full flex-shrink-0 flex justify-center px-4">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full max-w-2xl rounded-lg shadow-lg"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


const products = [
  {
    id: 32,
    name: "Стандарт",
    description: (
      <ul>
        <li className="font-bold">
          Доступ к информации и тренировкам в закрытом Telegram-канале на 14 дней.{" "}
          <a href="https://t.me/+LZlmsjuKTT42YjQy" className="text-rose-600">
            Перейти.
          </a>
        </li>
        <li className="font-bold">
          Без обратной связи и проверки домашних заданий
        </li>
        <li className="font-bold text-rose-600">
          Важно: Вам необходимо самостоятельно отправить запрос на добавление в группу и внимательно указать свои данные в анкете.
        </li>
      </ul>
    ),
    price: "10 000",
  },
  {
    id: 33,
    name: "Стандарт+",
    description: (
      <ul>
        <li className="font-bold">
          Доступ к информации и тренировкам в закрытом Telegram-канале на 14 дней.{" "}
          <a href="https://t.me/+LZlmsjuKTT42YjQy" className="text-rose-600">
            Перейти.
          </a>
        </li>
        <li className="font-bold">
          Проверка только техники дыхания в общем чате WhatsApp — в течение первых 72 часов после старта курса
        </li>
        <li className="font-bold text-rose-600">
          Важно: Вам необходимо самостоятельно отправить запрос на добавление в группу и внимательно указать свои данные в анкете.
        </li>
      </ul>
    ),
    price: "15 000",
  },
  {
    id: 34,
    name: "VIP",
    description: (
      <div className="px-4">
        <p className="italic text-gray-600 mb-6">
          Если ты хочешь быть уверена, что всё делаешь правильно, не согласна на "как получится", и по-настоящему стремишься к результату — этот тариф для тебя.
        </p>
        <ul>
          <li className="font-bold">
            Доступ к информации и тренировкам в закрытом Telegram-канале на 14 дней.{" "}
            <a href="https://t.me/+LZlmsjuKTT42YjQy" className="text-rose-600">
              Перейти.
            </a>
          </li>
          <li className="font-bold">
            Проверка техники дыхания и всех упражнений в общем VIP-чате WhatsApp
          </li>
          <li className="font-bold">
            Жёсткий режим и тотальный контроль — чтобы не осталось ни шанса «отмазаться»
          </li>
        </ul>
        <p className="font-bold text-rose-600 mt-4">
          Важно: Проверка домашних заданий проводится только в течение первых 7 дней с момента начала курса. Проверка осуществляется в закрытой группе WhatsApp. Запрос в группу вы отправляете самостоятельно, внимательно указывая данные в анкете
        </p>
      </div>
    ),
    price: "20 000",
  },
  {
    id: 35,
    name: "VIP +",
    description: (
      <div className="px-4">
        <p className="italic text-gray-600 mb-6">
          Если ты хочешь личного контроля от Алины Шпак — этот тариф для тебя.
        </p>
        <ul>
          <li className="font-bold">
            Доступ к информации и тренировкам в закрытом Telegram-канале на 14 дней.{" "}
            <a href="https://t.me/+LZlmsjuKTT42YjQy" className="text-rose-600">
              Перейти.
            </a>
          </li>
          <li className="font-bold">
            Проверка техники дыхания и всех упражнений лично Алиной Шпак в WhatsApp
          </li>
          <li className="font-bold">
            Жёсткий режим и тотальный контроль — чтобы не осталось ни малейшего шанса «отмазаться»
          </li>
        </ul>
        <p className="font-bold text-rose-600 mt-4">
          Важно: Проверка домашних заданий проводится только в течение первых 7 дней с момента начала курса. Проверка осуществляется в закрытой группе WhatsApp. Запрос в группу вы отправляете самостоятельно, внимательно указывая данные в анкете
        </p>
      </div>
    ),
    price: "100 000",
  },
];

export const Pro = () => {
  const aboutRef = useRef<HTMLDivElement>(null);
  const resultsRef = useRef<HTMLDivElement>(null);
  const qaRef = useRef<HTMLDivElement>(null);
  const howItGoesRef = useRef<HTMLDivElement>(null);
  const rulesRef = useRef<HTMLDivElement>(null);
  const contraindicationRef = useRef<HTMLDivElement>(null);
  const buyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash === "buy" && buyRef.current) {
      setTimeout(() => {
        window.scrollTo(0, buyRef.current?.offsetTop || 0);
      }, 100);
    }
  }, []);

  const scrollTo = (name: string) => {
    if (name === "about") window.scrollTo(0, aboutRef?.current?.offsetTop || 0);
    if (name === "results") {
      window.scrollTo(0, resultsRef?.current?.offsetTop || 0);
    }
    if (name === "qa") window?.scrollTo(0, qaRef?.current?.offsetTop || 0);
    if (name === "howItGoes") {
      window?.scrollTo(0, howItGoesRef?.current?.offsetTop || 0);
    }
    if (name === "rules") {
      window?.scrollTo(0, rulesRef?.current?.offsetTop || 0);
    }
    if (name === "contraindication") {
      window?.scrollTo(0, contraindicationRef?.current?.offsetTop || 0);
    }
    if (name === "buy") window?.scrollTo(0, buyRef?.current?.offsetTop || 0);
  };

  return (
    <div className="relative">
      <HeaderPro scrollTo={scrollTo} />
      <HeroSection scrollTo={scrollTo} />
      <div ref={aboutRef} />
      <AboutSection />
      <div ref={resultsRef} />
      <Results />
      <div ref={howItGoesRef} />
      <HeroImageContainer imageName="how-pass.png" />
      <HowItGoes />
      <div ref={rulesRef} />
      <HeroImageContainer imageName="rules.png" />
      <Rules />
      <BeforeAfter />
      <div ref={contraindicationRef} />
      <ContraindicationsPro />
      <div ref={buyRef} />
      <Products
        date={"16 сентября"}
        products={products}
        closed={false}
        closedTitle="Набор закрыт. Ожидайте следующий"
      />
      <Footer background="gray" />
    </div>
  );
};
